import img2 from "../../Assets/images/emp-candidate.svg";
import img1 from "../../Assets/images/for-talent.png";

import img3 from "../../Assets/images/Insights.png";
import img4 from "../../Assets/images/talent-partners-img-2.png";

import simg1 from "../../Assets/images/s-img1.svg";
import simg2 from "../../Assets/images/s-img2.svg";

const Solutions = {
  "for-talent-partners": {
    title: "For Talent Partners",
    subtitle: "Empower Your Recruitment Workflow",
    description:
      "Ann helps staffing and recruiting firms move faster, smarter, and more efficiently—matching top talent with top roles using AI-driven automation.",
    section2: [
      {
        heading: "Deliver Candidates at Lightning Speed",
        text: "In a competitive market, speed and accuracy are everything. Ann’s automation tools let recruiters deliver qualified candidates to clients in record time—without compromising on quality.",
        image: img1,
        image2: simg2,
      },
    ],
    section3: [
      {
        heading: "Insights That Elevate Your Value",
        text: "From interview scores to behavioral metrics, Ann equips you with the data that earns trust—and repeat business. Every match you make is backed by intelligence.",
        // image: resumeimage1,
      },
    ],
    section4: [
      {
        heading: "Designed for Recruiters, Built for Speed",
        text: "Ann simplifies collaboration between recruiters, clients, and candidates. Share updates, align on goals, and keep hiring momentum strong.",
        p1: "Easy-to-use recruiter dashboard",
        p2: "Collaborative candidate reviews",
        p3: "Built-in communication tools",
        image: img4,
      },
    ],
    finalsection: [
      {
        heading: "Ready to Supercharge Your Staffing Agency?",
        text: "Let Ann handle the heavy lifting while you focus on closing roles faster and building long-term client relationships.",
        button: "Request a Demo",
      },
    ],
  },

  "for-employers": {
    title: "For Employers",
    subtitle: "Hire Faster. Smarter. Fairer.",
    description:
      "With Ann, employers get instant access to top candidates through AI-led shortlisting, unbiased screening, and real-time interview insights—all in one seamless platform.",
    section2: [
      {
        heading: "Find the Right Candidates, Instantly",
        text: "Stop sifting through piles of resumes. Ann delivers a shortlist of high-fit candidates—so your hiring team can focus only on the best.",
        image: img2,
        image2: simg1,
      },
    ],
    section3: [
      {
        heading: "High-Volume Screening, Zero Compromise",
        text: "Whether you’re hiring for one role or one hundred, Ann scales with your needs. Let AI conduct structured interviews, flag anomalies, and provide detailed feedback—so you make faster decisions with confidence.",
      },
      {
        heading: "Seamlessly Integrated with Your Workflow",
        text: "Connect Ann with your ATS, calendar, and team workflows with ease. No disruption—just instant productivity and smarter collaboration.",
      },
    ],
    section4: [
      {
        heading: "Insights That Make Hiring Smarter",
        text: "Ann transforms every interaction into actionable data—from skill-matching reports to candidate behavior highlights. Every decision is backed by evidence, not assumptions.",
        p1: "In-depth Interview Reports",
        p2: "Real-Time Candidate Scoring",
        p3: "Post-Interview Feedback & Ratings",
        image: img3,
      },
    ],
    finalsection: [
      {
        heading: "Hire Better, Starting Today",
        text: "Give your hiring team the power of AI. Start shortlisting smarter, interviewing faster, and hiring more fairly—with Ann.",
        button: "Book a Call",
      },
    ],
  },
};

export default Solutions;
